// AUTO-GENERATED — DO NOT EDIT BY HAND.
// Source of truth: aol_schemas.errors (aol-us-shared). Regenerate with
// `./devops build types` (emitter: aol_schemas/export_errors.py).

export const ErrorBucket = {
  TRANSIENT: 'transient',
  QUOTA: 'quota',
  RATE_LIMIT: 'rate_limit',
  FATAL: 'fatal',
  BENIGN: 'benign',
} as const;
export type ErrorBucket = (typeof ErrorBucket)[keyof typeof ErrorBucket];

export const RealtimeErrorCode = {
  INSUFFICIENT_QUOTA: 'insufficient_quota',
  BILLING_HARD_LIMIT_REACHED: 'billing_hard_limit_reached',
  RATE_LIMIT_EXCEEDED: 'rate_limit_exceeded',
  TOO_MANY_REQUESTS: 'too_many_requests',
  SERVER_ERROR: 'server_error',
  INTERNAL_ERROR: 'internal_error',
  INVALID_REQUEST_ERROR: 'invalid_request_error',
  AUTHENTICATION_ERROR: 'authentication_error',
  INPUT_AUDIO_BUFFER_COMMIT_EMPTY: 'input_audio_buffer_commit_empty',
  MCP_TIMEOUT: 'mcp_timeout',
  UPSTREAM_UNRECOVERABLE: 'upstream_unrecoverable',
  HISTORY_REPLAY_FAILED: 'history_replay_failed',
  UNKNOWN: 'unknown',
} as const;
export type RealtimeErrorCode = (typeof RealtimeErrorCode)[keyof typeof RealtimeErrorCode];
